/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { gnoment } from 'shared-ui/gnoment';
import { FETCH_AVAILABILITY_API, FETCH_AVAILABILITY } from '../constants/actions';
import { LOCATION_TZ, BOOKING_HOUR_CUTOFF } from '../constants/hunting-permit-constants';

export const availabilityEpic = (action$) =>
    action$.pipe(
        ofType(`${FETCH_AVAILABILITY_API}_SUCCESS`),
        map(({ payload }) => {
            const newPayload = [...payload].filter((p) => {
                const stringDateTime = `${p.permit_type_end} ${BOOKING_HOUR_CUTOFF[p.permit_id]}`;
                const permitEndDate = gnoment.tz(
                    stringDateTime,
                    LOCATION_TZ[p.permit_id]
                );
                return gnoment().isBefore(permitEndDate);
            });
            return { type: `${FETCH_AVAILABILITY}_SUCCESS`, payload: newPayload };
        })
    );
